module.exports = __webpack_public_path__ + "static/media/DBKFoundryEmptyINTA0007_design_clean_v001.dba1b4a5.webp";